var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(this.languagesLoaded && _vm.$auth.ready())?_c(_vm.layout,{tag:"component"},[_c('router-view',{key:_vm.routeKey})],1):_c('div',[_vm._v("\n    Loading...\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }